export default "__VITE_ASSET__I5r4y0U3__"